var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolomonIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1427 34.1427C41.6435 26.6418 41.9397 14.6665 35.0343 6.8103L20 19.9999L6.81032 35.0343C14.6665 41.9397 26.6418 41.6435 34.1427 34.1427V34.1427Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85713 5.85746C13.358 -1.64339 25.3333 -1.93956 33.1895 4.96582L19.9998 20.0003L4.96557 33.1898C-1.93989 25.3337 -1.64364 13.3583 5.85713 5.85746V5.85746Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1895 4.96573L4.96562 33.1897C5.25093 33.5143 5.54718 33.8328 5.85726 34.1427C6.16726 34.4527 6.48578 34.7489 6.81046 35.0344L35.0342 6.81041C34.7489 6.48573 34.4526 6.16729 34.1425 5.85721C33.8327 5.54737 33.5142 5.25104 33.1895 4.96573V4.96573Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42657 6.95598L8.85837 8.28465H10.2553L9.12516 9.10566L9.5568 10.4343L8.42657 9.61316L7.29634 10.4343L7.72813 9.10566L6.5979 8.28465H7.99493L8.42657 6.95598Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 6.95598L15.9943 8.28465H17.3912L16.261 9.10566L16.6927 10.4343L15.5625 9.61316L14.4323 10.4343L14.8641 9.10566L13.7338 8.28465H15.1308L15.5625 6.95598Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42657 13.9128L8.85837 15.2414H10.2553L9.12516 16.0625L9.5568 17.3912L8.42657 16.57L7.29634 17.3912L7.72813 16.0625L6.5979 15.2414H7.99493L8.42657 13.9128Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 13.9128L15.9943 15.2414H17.3912L16.261 16.0625L16.6927 17.3912L15.5625 16.57L14.4323 17.3912L14.8641 16.0625L13.7338 15.2414H15.1308L15.5625 13.9128Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9946 10.4343L12.4264 11.763H13.8233L12.6931 12.5841L13.1248 13.9127L11.9946 13.0916L10.8644 13.9127L11.2961 12.5841L10.1659 11.763H11.5629L11.9946 10.4343Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolomonIslands);
export default __webpack_public_path__ + "static/media/solomon_islands.df3087b234608e768bf8ec2d80318548.svg";
export { ForwardRef as ReactComponent };